import { useQuery } from '@tanstack/vue-query';
import { APP_CONFIGURATION_ROUTE } from '@/constants/routes.constants';
import { getAppConfiguration } from '@/services/app-configuration-service';
import type { ConfigurationResponse } from '@/types/shared-types';
import { checkQueryClient } from '@/utils/checkQueryclient';

export const useFeatureToggleQuery = () => {
    checkQueryClient();

    return useQuery({
        queryKey: [APP_CONFIGURATION_ROUTE],
        queryFn: () => getAppConfiguration(),
        select: (data: ConfigurationResponse) => data?.features,
    });
};
